/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
const $hero          = document.querySelector('[data-component="sections/hero"]');
const $btnContact    = $el.find('.btn-investir');
const $categoryBtn   = $el.find('.breadcrumb-category');
const $categoryMenu  = $el.find('.category-menu');
const $overlay       = $el.find('.wrapper-categories-overlay');
const $productHeader = $el.find('.product-header');
const $btnOpenModal  = $el.find('[data-open-modal]');
const $modalInvestir = $('[data-component="modals/modal-investir"]');

$btnOpenModal.on('click', function() {
    const $this = $(this);
    const attributes = {
        aditionalAplication: $this.data('aditional-aplication'),
        minAplication: $this.data('min-aplication'),
        minBalance: $this.data('min-balance'),
        platforms: $this.data('platforms'),
        productName: $this.data('product-name'),
        isInstitucional: ($this.data('institucional') ? true : false),
    }

    $modalInvestir.trigger('open', [attributes]);
});

const screenSize = $hero.offsetHeight;
window.addEventListener('scroll', () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > screenSize) {
        el.classList.add('show-btn');
    } else {
        el.classList.remove('show-btn');
    }
});
window.dispatchEvent(new CustomEvent('scroll'));

$categoryBtn.on('click', function() {
    $categoryMenu
       .add($overlay)
       .add($categoryBtn)
       .toggleClass('active');
});

$overlay.on('click', function() {
    $categoryMenu
       .add($overlay)
       .add($categoryBtn)
       .removeClass('active');
});

$window
    .on('resize', function () {
        $overlay.css('top', $productHeader.offset().top)
    });
